import type { GA4Item } from "../types/GA4Types.type";
import type { DataLayerProduct } from "@ocm/global-types";
import { getEpoqTestGroup } from "./services.epoq";
import GA4ItemListService from "./services.ga4ItemList";

export const getGA4Items = (items: DataLayerProduct[], listId?: string): GA4Item[] => {
	const ga4Items: GA4Item[] = [];
	const epoqTestGroup = getEpoqTestGroup();
	const storedItems = GA4ItemListService.getItems();

	items.forEach((item, index) => {
		const categories = item.categories[0].split("/");
		const itemListId = listId ?? storedItems.find((_item) => _item.id === item.style)?.listId;
		const product: GA4Item = {
			index,
			item_id: item.style,
			item_name: item.name,
			item_brand: item.label,
			vendorCode: item.vendorCode,
			vendorName: item.vendorName,
			price: Number(item.price),
			quantity: Number(item.quantity),
			...(categories[0] && { item_category: categories[0] }),
			...(categories[1] && { item_category2: categories[1] }),
			...(categories[2] && { item_category3: categories[2] }),
			...(categories[3] && { item_category4: categories[3] }),
			...(categories[4] && { item_category5: categories[4] }),
			...(item.variant && { item_variant: item.variant }),
			...(item.msrp && item.price && { discount: Number(item.msrp) - Number(item.price) }),
			...(itemListId && { item_list_id: itemListId }),
			...(epoqTestGroup && { epoqPLS_ABTest: epoqTestGroup }),
		};
		ga4Items.push(product);
	});

	return ga4Items;
};
